import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { deleteUsersFromAPI, fetchUsersFromAPI, uploadUserFileToAPI } from "../../../services/UserService";


export const fetchUsers = createAsyncThunk(
  "users/fetchUsers",
  async ({ page, perPage, search, columnFilters, sort }, { rejectWithValue }) => {
    try {
      const response = await fetchUsersFromAPI(page, perPage, search, columnFilters, sort);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal mengambil data pengguna");
    }
  }
);


export const deleteUser = createAsyncThunk(
  "users/deleteUser",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await deleteUsersFromAPI(userId);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal menghapus data pengguna");
    }
  }
);

// Upload User File
export const uploadUserFile = createAsyncThunk(
  "users/uploadUserFile",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await uploadUserFileToAPI(formData);
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error?.message || "Upload gagal.",
        detail: error?.detail || [],
        status: error?.status || "failed"
      });
    }
  }
);


const userSlice = createSlice({
  name: "users",
  initialState: {
    users: [],
    currentPage: 1,
    lastPage: 1,
    perPage: 10,
    firstItem: 1,
    userSearch: "",
    loading: false,
    error: null,
    totalCount:0,
    admins: 0,
    vendorUsers: 0,
    roles: 0,
    keywordSearch:"",
    columnFilters: {} // New state for column-specific filters
  },
  reducers: {
    setSearchUser: (state, action) => {
      state.userSearch = action.payload;
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setVisibilityFilter: (state, action) => {
      state.currentFilter = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setKeywordSearch: (state, action) => {
      state.keywordSearch = action.payload;
    },
    setColumnFilters: (state, action) => {
      state.columnFilters = action.payload;
    },
    resetUserState: (state) => {
      state.users = [];
      state.currentPage = 1;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        const users = action.payload.users;
        state.loading = false;
        state.users = users.data;
        state.currentPage = users.current_page;
        state.lastPage = users.last_page;
        state.perPage = users.per_page;
        state.firstItem = users.from; // ✅ Ambil `from` dari API
        state.totalCount = users.total;
        state.admins = users.admins ?? 0;
        state.vendorUsers = users.vendorUsers ?? 0;
        state.roles = users.roles ?? 0;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.users = state.users.filter(user => user.id !== action.payload);
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(uploadUserFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadUserFile.fulfilled, (state, action) => {
        state.loading = false;
        // Optionally refresh the user list after successful upload
        // You can dispatch fetchUsers here if needed
      })
      .addCase(uploadUserFile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setSearchUser, setPage, setVisibilityFilter, setPerPage, setKeywordSearch, setColumnFilters, resetUserState } = userSlice.actions;
export default userSlice.reducer;
